import { useState, type Dispatch } from "react";
import type { EditorAction } from "../editor/reducers";
import { Input } from "@acdc2/ui/components/input";
import { TableEditorStep } from "./TableEditorStep";
import { AccessButton } from "@acdc2/ui/components/access-button";
import { Icon } from "@mdi/react";
import { mdiTableRow, mdiTableRowPlusAfter, mdiTableRowRemove } from "@mdi/js";
import { useTranslation } from "react-i18next";

type Props = {
  dispatch: Dispatch<EditorAction>;
  isSelectionFullWidth: boolean;
  isSelectionFullHeight: boolean;
  isSelectionSpanningSingleRow: boolean;
};

export function TableEditorStep3({
  dispatch,
  isSelectionFullWidth,
  isSelectionFullHeight,
  isSelectionSpanningSingleRow,
}: Props) {
  const { t } = useTranslation();
  const [divisor, setDivisor] = useState(2);

  return (
    <TableEditorStep
      value="step3"
      iconPath={mdiTableRow}
      title={t("TableEditorStep3.title")}
      description={t("TableEditorStep3.description")}
    >
      <div className="flex gap-2">
        <Input
          type="number"
          placeholder={t("TableEditorStep3.inputs.divider.placeholder")}
          value={divisor}
          onChange={(event) => setDivisor(parseInt(event.target.value))}
        />
        <AccessButton
          type="button"
          variant="outline"
          onClick={() => dispatch({ type: "divideTableRow", divisor })}
          disabled={!isSelectionFullWidth || !isSelectionSpanningSingleRow}
        >
          <Icon path={mdiTableRowPlusAfter} size="1rem" />
          {t("TableEditorStep3.inputs.split.label")}
        </AccessButton>
      </div>
      <AccessButton
        type="button"
        variant="outline"
        onClick={() => dispatch({ type: "deleteTableRows" })}
        disabled={!isSelectionFullWidth || isSelectionFullHeight}
      >
        <Icon path={mdiTableRowRemove} size="1rem" />
        {t("TableEditorStep3.inputs.delete.label")}
      </AccessButton>
    </TableEditorStep>
  );
}
